import React, {Component} from 'react';
import Text from "@amzn/meridian/text";
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column";
import Table, {TableCell, TableRow} from "@amzn/meridian/table";
import CommonFilters from '../../commons/CommonFilters';
import {
    dwellingRowMapping,
    dwellingRowMappingForDS,
    dwellingRowMappingForXPT
} from '../../commons/dataStore/PackageResultsData';
import { processConditionalMetrics } from '../../util/MetricUtils';
import {handlePackageStateMapping, oldTimeZoneMapper} from "../../commons/CommonUtils";
import {FiltersStateContext} from '../../commons/context/FiltersStateContext';
import Link from "@amzn/meridian/link";
import Loader from "@amzn/meridian/loader";
import Tag from "@amzn/meridian/tag"
import Tooltip from "@amzn/meridian/tooltip";
import chevronDownSmallTokens from "@amzn/meridian-tokens/base/icon/chevron-down-small"
import chevronRightSmallTokens from "@amzn/meridian-tokens/base/icon/chevron-right-small"
import Icon from "@amzn/meridian/icon"
import {FormattedMessage} from "react-intl";
import RefreshTimer from "../../commons/RefreshTimer";


let INBOUND_STATUSES = ["Manifested" , "In Transit (DS -> DS)", "In Transit (FC -> DS)"]
//We might need to add marked for reprocess here
let HELD_STATUSES = ["Pending Reinduct", "Pending Induct"]

export default class DwellingDataUI extends Component {

    static contextType = FiltersStateContext;

    constructor(props) {
        super(props)
        this.state = {
          expandedSections : [],
          view : "DWELLING_VIEW",
          data : props.data,
          isCPTFilterEnabled: props.isCPTFilterEnabled
        }

        this.getMetricFromPackageToColumnMap = (section, column, direction) => {
            section = section && section.split(":", 2)[1] ? section.split(":", 2)[1] : section ;
            var sectionData = this.props.data.filter(status => status.packageStatus === section);
            var timeToMetricDataMapForSection = sectionData && sectionData.length > 0 ? sectionData : [];
            var t = direction ?  timeToMetricDataMapForSection.find(section => section.metaDataMap ? section.metaDataMap.direction === direction : null) ? 
            timeToMetricDataMapForSection.find(section => section.metaDataMap ? section.metaDataMap.direction === direction : null).columnToViewDataMap : [] :
                (timeToMetricDataMapForSection.length > 0 ? timeToMetricDataMapForSection[0].columnToViewDataMap : [])  
            var col = t.length === 0 ? 0: JSON.stringify(t).match(/[0-9]*_MIN/g)[0]; 
            return t[column + "-" + col] ? t[column + "-" + col].value : 0
        }

        /**
        * This calculates total count for section metric
        */
       this.getSectionMetricFromSubsectionData = (section, column) => {

        var totalCount = 0;
        section.Subsections.length > 0 ? 
        section.Subsections.map(subsection =>  subsection.Section ?
                subsection.Subsections.map(s => totalCount+= Number(this.getMetricFromPackageToColumnMap((s.localeCompare(subsection.Section) !== 0 ? s : ""), column,  ""))) :
        (totalCount += Number(this.getMetricFromPackageToColumnMap(subsection.localeCompare(section.Section) !== 0 ? subsection.split(" (", 1)[0]: "", column,  subsection.split(" (", 2)[1] ? subsection.split(" (", 2)[1].split(")" , 1)[0] : "")))) :
        //In case when there is no subsection
        totalCount += Number(this.getMetricFromPackageToColumnMap(section.Section, column))
        return totalCount

    }
    
        this.toggleRow = section => {

            if (this.state.expandedSections.indexOf(section) !== -1) {
                this.setState({
                expandedSections : this.state.expandedSections.filter(expandedSection => expandedSection !== section)}
                )
            } 
            else  {
                this.setState({
                expandedSections : this.state.expandedSections.concat(section)
                })
            } 
        }

        this.isSectionExpanded = section => {
            return (this.state.expandedSections.indexOf(section) !== -1);
        }

        /**
         * This function calculates process status for section
         */
        this.getProcessStatusForSection = (subsection, column) => {

            var subsectionStatus = subsection.length > 0 ?  subsection.Section ? subsection : subsection[0].split(" (", 1)[0] : ""
            var sectionData = this.props.data.filter(status => status.packageStatus === subsectionStatus);
            var timeToMetricDataMapForSection = sectionData && sectionData.length > 0 ? sectionData[0].columnToViewDataMap : []  
      
            if (timeToMetricDataMapForSection.length === 0 || !timeToMetricDataMapForSection[column + "-" + JSON.stringify(timeToMetricDataMapForSection).match(/[0-9]*_MIN/g)[0]]) return null;
            var col = column + "-" + JSON.stringify(timeToMetricDataMapForSection).match(/[0-9]*_MIN/g)[0]
            var displayString = timeToMetricDataMapForSection[col].processStatus + " " +  (new Date(timeToMetricDataMapForSection[col].cpt).getHours() < 10 
             ? "0" + new Date(timeToMetricDataMapForSection[col].cpt).getHours() : 
            new Date(timeToMetricDataMapForSection[col].cpt).getHours()) + ":" +
            (new Date(timeToMetricDataMapForSection[col].cpt).getMinutes() < 10 ? "0" + new Date(timeToMetricDataMapForSection[col].cpt).getMinutes() : 
            new Date(timeToMetricDataMapForSection[col].cpt).getMinutes()) + " CPT"

            switch(timeToMetricDataMapForSection[col].processStatus) {

                case "Failed":
                    return <Tooltip position="left" title={displayString}><Tag type="error"></Tag></Tooltip>
                case "Current":
                    return  <Tooltip position="left" title={timeToMetricDataMapForSection[col].processStatus}><Tag type="theme"></Tag></Tooltip>
                case "At Risk":
                    var string = timeToMetricDataMapForSection[col].count + " " + timeToMetricDataMapForSection[col].processStatus
                    return <Tooltip position="left" title={string}><Tag type="warning"></Tag></Tooltip>
                default:
                  return null
              }

            }

        this.constructState = (section, cycleColumn, CPTColumn, sectionHeader) => {

            let subsections = Array.isArray(section)  ? [].concat.apply([], section): section;
            //TODO : Change dwell start to end based on time
            let dwellTime = parseInt(JSON.stringify(this.props.data).match(/[0-9]*_MIN/g)[0].replace("_MIN", ""), 10);
            if (isNaN(dwellTime)) {
                dwellTime = 0;
            }

            var stationTimeZone = this.props.stationTimeZone;
            var timeZone = stationTimeZone ? oldTimeZoneMapper(stationTimeZone) : undefined;

            var values = {
                packageStatuses : Array.isArray(subsections ) ? subsections  : [subsections],
                CPT : [CPTColumn],
                cycles: [cycleColumn],
                packageTypes  : ["Core Volume"],
                startPDD : this.context.selectedFilterValues.startPDD,
                endPDD : this.context.selectedFilterValues.endPDD,
                dwellStartTime : JSON.stringify(this.props.data).match(/[0-9]*_MIN/g)[0],
                dwellEndTime : "0_MIN",
                leg : this.context.selectedFilterValues.leg,
                stationArrivalTime :  ((Array.isArray(subsections) && JSON.stringify(INBOUND_STATUSES) === JSON.stringify(subsections)) ||  INBOUND_STATUSES.includes(subsections)) ? [new Date().toISOString().substr(0, 10)] : [] ,
                eadSection : HELD_STATUSES.includes(sectionHeader) || HELD_STATUSES.includes(subsections) ? true : false,
                page: "DWELL"
            }

            // Adding lastUpdatedStart and lastUpdatedEnd based on dwell time
            if (dwellTime !== 0) {
                let currentDate = new Date(new Date(Date.now()).toLocaleString('en-US', {timeZone: timeZone}));
                let resetDate = new Date(new Date(Date.now() - dwellTime*60*1000).toLocaleString('en-US', {timeZone: timeZone}));

                let endDate;

                if (
                    currentDate.getHours() < resetDate.getHours()
                    || (
                        currentDate.getHours() === resetDate.getHours()
                        && currentDate.getMinutes() < resetDate.getMinutes()
                    )
                ) {
                    endDate = new Date(Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), resetDate.getHours(), resetDate.getMinutes(), 0));
                } else {
                    endDate = new Date(Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + 1, resetDate.getHours(), resetDate.getMinutes(), 0));
                }
                values["lastUpdatedStart"] = new Date(endDate.getTime() - 24*60*60*1000);
                values["lastUpdatedEnd"] = new Date(endDate.getTime());
                values["enableDwellFilter"] = false;
            }

            //Redirect to search path
            var path = window.location.href;
            var searchPath = path[path.length - 1] === "/" ? path + "packageSearch/" : path + "/packageSearch/";
            
           return searchPath + JSON.stringify({...values , ...this.props.appliedFilterURL });

        }

        this.dwellingDataMapping = (viewType) => {
            if (viewType === "DEFAULT_VIEW") {
                return dwellingRowMapping;
            } else {
                if (viewType === "XPT_VIEW") {
                    return dwellingRowMappingForXPT;
                } else if (viewType === "DS_VIEW") {
                    return dwellingRowMappingForDS;
                }
                return dwellingRowMapping;
            }
        }
     }


    render() {
        
        const formattedIdPrefix = "commons.";
        const viewType = this.props.viewTypeForStation;

        const Columns = this.props.filterData.cycles.length > 0 ? this.props.filterData.cycles :
         [{"cycleId":"CYCLE_1","cycleName":"CYCLE_1"},{"cycleId":"NONE","cycleName":"No Cycle"}]

        const CPTColumns = this.props.filterData.CPT.length > 0 ? this.props.filterData.CPT :
            [{"id":"NONE","label":"Unplanned"},{"id":"ALL","label":"ALL"}]

        let dwellingDataMapping = this.dwellingDataMapping(this.props.viewTypeForStation);
        // Process row mapping based on conditional metrics
        dwellingDataMapping =  processConditionalMetrics(this.props.data, dwellingDataMapping);

        return (
        <Column spacing="medium" spacingInset={this.props.spacingInset_shorthand3}>
            <CommonFilters view={this.state.view} />
            <RefreshTimer deps={[this.props.data]}/>
            <Row widths="100%" wrap="down">
                <div style={{ overflowX: "auto", width: "100%" }}>
                    <Table  spacing="medium"
                            spacingInset="medium"
                            headerRows={1}
                            headerColumns={1}
                            fixHeaderRows = {true}
                            fixHeaderRowsFullWidth={true}
                            stickyHeaderColumn={true} >
                    <TableRow >
                        <TableCell alignmentHorizontal = "left">
                       
                           <Text type="h100">
                               <FormattedMessage id="dwell.status" defaultMessage="Status"/>
                           </Text>
                        </TableCell>
                        {this.state.isCPTFilterEnabled ? CPTColumns.map(col =>
                                <TableCell alignmentHorizontal = "right"><Text type="h100">{col.label}</Text></TableCell>) :
                            Columns.map(col =>
                                    <TableCell alignmentHorizontal = "right"><Text type="h100">{col.cycleName}</Text></TableCell>)}
                    </TableRow>
                    { this.props.isLoading ? <TableRow><TableCell columnSpan = {7} alignmentHorizontal = "center"><Loader/></TableCell></TableRow>: 
                     this.props.data && this.props.data.length > 0 && dwellingDataMapping.map(section => (
                
                    <TableRow highlightOnHover={true} key={section.Section} open={this.isSectionExpanded(section.Section)} onClick={() => this.toggleRow(section.Section)}>
                            <TableCell  alignmentHorizontal = "left"><FormattedMessage id ={formattedIdPrefix.concat(section.Section.split(' ').join('_').toLocaleLowerCase())} defaultMessage={section.Section}/></TableCell>
                        {this.state.isCPTFilterEnabled ? CPTColumns.map( col =>
                        <TableCell alignmentHorizontal = "right">
                            {this.getProcessStatusForSection(section.Subsections.filter(subsection => !subsection.Section).filter(subsection => subsection.split(" (", 1)[0] === section.ProcessStatus), col.id)}
                            {this.getSectionMetricFromSubsectionData(section, col.id).toString() !== "0" ?

                            <Link href =  {this.constructState( section.Subsections.length > 0 ?  section.Subsections.map( subsection => {return subsection.Section ? subsection.Subsections.filter(sub=> sub !== subsection.Section.split(":", 1)[0]).map(s => s.split(":", 1)[0]) : 
                                subsection}) : section.Section, null, col.label, section.Section)} type="secondary">
                            {" "}

                            {this.getSectionMetricFromSubsectionData(section, col.id)}
                            </Link> : this.getSectionMetricFromSubsectionData(section, col.id)}
                        </TableCell> ): Columns.map( col =>
                            <TableCell alignmentHorizontal = "right">
                                {this.getProcessStatusForSection(section.Subsections.filter(subsection => !subsection.Section).filter(subsection => subsection.split(" (", 1)[0] === section.ProcessStatus), col.cycleId)}
                                {this.getSectionMetricFromSubsectionData(section, col.cycleId).toString() !== "0" ?

                                    <Link href =  {this.constructState( section.Subsections.length > 0 ?  section.Subsections.map( subsection => {return subsection.Section ? subsection.Subsections.filter(sub=> sub !== subsection.Section.split(":", 1)[0]).map(s => s.split(":", 1)[0]) :
                                        subsection}) : section.Section, col.cycleName, null, section.Section)} type="secondary">
                                        {" "}

                                        {this.getSectionMetricFromSubsectionData(section, col.cycleId)}
                                    </Link> : this.getSectionMetricFromSubsectionData(section, col.cycleId)}
                            </TableCell> )}
                 
                        { section.Subsections.map(subsection => subsection.Section ? subsection.Subsections.map(sub => sub === subsection.Section ? 
                          <TableRow key={subsection.Section} open={this.isSectionExpanded(subsection.Section)} onClick={() => this.toggleRow(subsection.Section)}>
                                <TableCell alignmentHorizontal = "left">
                                    <Row spacingInset="none none none medium">
                                        <Icon tokens={this.isSectionExpanded(subsection.Section) ? chevronDownSmallTokens : chevronRightSmallTokens}/>
                                        <FormattedMessage id ={formattedIdPrefix.concat(subsection.Section.toLocaleLowerCase().split(' ').join('_'))} defaultMessage={subsection.Section}/></Row>
                                </TableCell>
                                {this.state.isCPTFilterEnabled? CPTColumns.map( col => <TableCell alignmentHorizontal = "right">
                                    {this.getSectionMetricFromSubsectionData(subsection , col.id).toString() !== "0" ?
                                    <Link href = {this.constructState(subsection.Subsections.length > 0 ? subsection.Subsections.filter( s => s.split(":", 1)[0] !== subsection.Section).map(s => s.split(":", 1)[0]) : 
                                        subsection.Section, null,col === "_MIN" ?   JSON.stringify(this.props.data).match(/[0-9]*_MIN/g)[0] : col.label, subsection.Section)} type="secondary">
                                        {this.getSectionMetricFromSubsectionData(subsection, col.id)}
                                    </Link> : this.getSectionMetricFromSubsectionData(subsection, col.id)}
                                </TableCell> ): Columns.map( col => <TableCell alignmentHorizontal = "right">
                                    {this.getSectionMetricFromSubsectionData(subsection , col.cycleId).toString() !== "0" ?
                                        <Link href = {this.constructState(subsection.Subsections.length > 0 ? subsection.Subsections.filter( s => s.split(":", 1)[0] !== subsection.Section).map(s => s.split(":", 1)[0]) :
                                            subsection.Section, col === "_MIN" ?   JSON.stringify(this.props.data).match(/[0-9]*_MIN/g)[0] : col.cycleName, null, subsection.Section)} type="secondary">
                                            {this.getSectionMetricFromSubsectionData(subsection, col.cycleId)}
                                        </Link> : this.getSectionMetricFromSubsectionData(subsection, col.cycleId)}
                                </TableCell> )} </TableRow> :
                                this.isSectionExpanded(subsection.Section) ? <TableRow>
                                      <TableCell  alignmentHorizontal = "left"><Row spacingInset="none none none xlarge"><FormattedMessage id ={formattedIdPrefix.concat(sub.split(":", 1)[0].split(" (")[0].toLocaleLowerCase().split(' ').join('_'))} defaultMessage={sub.split(":", 1)[0].split(" (")[0]}/></Row></TableCell> 
                                     {this.isCPTFilterEnabled? CPTColumns.map( col =>   <TableCell alignmentHorizontal = "right">
                                     {this.getMetricFromPackageToColumnMap(sub.split(":", 2)[1] ? sub.split(":", 2)[1] : sub.split(" (")[0], col.id, sub.split(" (", 2)[1] ? sub.split(" (", 2)[1].split(")" , 1)[0] : "").toString() !== "0" ?
                                <Link href = {this.constructState(sub.split(":", 2)[1] ? sub.split(":", 2)[0] : sub, null, col === "_MIN" ?   JSON.stringify(this.props.data).match(/[0-9]*_MIN/g)[0] : col.label, subsection.Section)} type="secondary">
                                    {this.getMetricFromPackageToColumnMap(sub.split(":", 2)[1] ? sub.split(":", 2)[1] : sub.split(" (")[0], col.id, sub.split(" (", 2)[1] ? sub.split(" (", 2)[1].split(")" , 1)[0] : "")}
                                          </Link> : this.getMetricFromPackageToColumnMap(sub.split(":", 2)[1] ? sub.split(":", 2)[1] : sub.split(" (")[0], col.id, sub.split(" (", 2)[1] ? sub.split(" (", 2)[1].split(")" , 1)[0] : "")}
                                </TableCell> ):Columns.map( col =>   <TableCell alignmentHorizontal = "right">
                                         {this.getMetricFromPackageToColumnMap(sub.split(":", 2)[1] ? sub.split(":", 2)[1] : sub.split(" (")[0], col.cycleId, sub.split(" (", 2)[1] ? sub.split(" (", 2)[1].split(")" , 1)[0] : "").toString() !== "0" ?
                                             <Link href = {this.constructState(sub.split(":", 2)[1] ? sub.split(":", 2)[0] : sub, col === "_MIN" ?   JSON.stringify(this.props.data).match(/[0-9]*_MIN/g)[0] : col.cycleName,null, subsection.Section)} type="secondary">
                                                 {this.getMetricFromPackageToColumnMap(sub.split(":", 2)[1] ? sub.split(":", 2)[1] : sub.split(" (")[0], col.cycleId, sub.split(" (", 2)[1] ? sub.split(" (", 2)[1].split(")" , 1)[0] : "")}
                                             </Link> : this.getMetricFromPackageToColumnMap(sub.split(":", 2)[1] ? sub.split(":", 2)[1] : sub.split(" (")[0], col.cycleId, sub.split(" (", 2)[1] ? sub.split(" (", 2)[1].split(")" , 1)[0] : "")}
                                     </TableCell> )} </TableRow>

                               : null ):
                            
                            <TableRow highlightOnHover={true}>
                                <TableCell alignmentHorizontal = "left"><Row spacingInset="none none none medium"><FormattedMessage id ={formattedIdPrefix.concat(handlePackageStateMapping("DWELL", section.Section, subsection, viewType).toLocaleLowerCase().split(' ').join('_'))} defaultMessage={subsection}/></Row></TableCell>
                            {this.state.isCPTFilterEnabled? CPTColumns.map(col =>

                            <TableCell alignmentHorizontal = "right">
                                {this.getMetricFromPackageToColumnMap(subsection.split(" (", 1)[0], col.id, subsection.split(" (", 2)[1] ? subsection.split(" (", 2)[1].split(")" , 1)[0] : "").toString() !== "0" ?
                                <Link href = {this.constructState(subsection, null, col.label)} type="secondary">
                               
                                {this.getMetricFromPackageToColumnMap(subsection.split(" (", 1)[0], col.id, subsection.split(" (", 2)[1] ? subsection.split(" (", 2)[1].splitF(")" , 1)[0] : "")}
                                
                                </Link> : this.getMetricFromPackageToColumnMap(subsection.split(" (", 1)[0], col.id, subsection.split(" (", 2)[1] ? subsection.split(" (", 2)[1].split(")" , 1)[0] : "")}
                            </TableCell>): Columns.map(col =>

                                <TableCell alignmentHorizontal = "right">
                                    {this.getMetricFromPackageToColumnMap(subsection.split(" (", 1)[0], col.cycleId, subsection.split(" (", 2)[1] ? subsection.split(" (", 2)[1].split(")" , 1)[0] : "").toString() !== "0" ?
                                        <Link href = {this.constructState(subsection, col.cycleName)} type="secondary">

                                            {this.getMetricFromPackageToColumnMap(subsection.split(" (", 1)[0], col.cycleId, subsection.split(" (", 2)[1] ? subsection.split(" (", 2)[1].split(")" , 1)[0] : "")}

                                        </Link> : this.getMetricFromPackageToColumnMap(subsection.split(" (", 1)[0], col.cycleId, subsection.split(" (", 2)[1] ? subsection.split(" (", 2)[1].split(")" , 1)[0] : "")}
                                </TableCell>)}
                        </TableRow> )
                        }
                    </TableRow>
                    ))}
                </Table>
                </div>
        </Row>
    </Column>
    )
  } 
}
                    


// WEBPACK FOOTER //
// ./src/components/dwelling/DwellingDataUI.js